import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "assessment-tools-setup",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "assessment-tools-setup" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
});
